import React, {Component} from 'react'
import { Route, Switch,Router } from 'react-router-dom';
import GuestLayout from './layout_guest'
import Login from '../pages/Signup/login.js'
import UpdatePassword from '../pages/Signup/update_password';
import history from '../history';
// import './app.css'
import PrivateRoute from '../components/privateroute';
class App extends Component {
  render () {
    return (
      <Router history={history}>
         <Switch >
          <Route path="/login" component={Login} />
          <Route path="/update-password" component={UpdatePassword}/>
          <PrivateRoute path="/" component={GuestLayout} />
        </Switch>
      </Router>
     
    )
  };
}

export default App